import { APP_COLORS } from '../../../helpers/constants'

export const formatPercentage = (percentage) => {
  if (percentage === '-') {
    return '0%'
  }

  if (Number(percentage) > 0) {
    return `▲ ${percentage}%`
  } else {
    return `▼ ${percentage}%`
  }
}

export const getPercentageColor = (percentage) => {
  if (percentage === '-') {
    return APP_COLORS.gray500
  }

  if (Number(percentage) > 0) {
    return APP_COLORS.green500
  } else {
    return APP_COLORS.red500
  }
}

export const isAppDownloadsDataValid = (appDownloadsData) => {
  return (
    !!appDownloadsData &&
    !!appDownloadsData.appDownloads &&
    appDownloadsData.appDownloads.total.downloads.value > 0
  )
}
